<template>
  <Teleport to="body">
    <div
      aria-live="polite"
      class="pointer-events-none fixed top-4 left-1/2 z-[600] flex w-full max-w-[420px] -translate-x-1/2 flex-col gap-2 px-4 md:left-auto md:right-6 md:top-6 md:translate-x-0 md:px-0"
    >
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :toast="toast"
        @dismiss="dismiss"
        @pause="pause"
        @resume="resume"
        @action="onAction"
      />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import Toast from '@/components/feedback/Toast.vue';
import { useToast } from '@/composables/useToast';

const { toasts, dismiss, pause, resume } = useToast();

function onAction(id: string): void {
  const toast = toasts.value.find((item) => item.id === id);
  if (!toast?.action) return;
  toast.action.onClick();
  dismiss(id);
}
</script>
